import React from "react";
import CV from "../../assets/cv.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={CV} download className="btn" >
        הורד קורות חייים
      </a>
      <a href="#contact" className="btn btn-primary" >בואו נדבר </a>
    </div>
  );
};

export default CTA;
